"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPortalCustomerQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const customer_type_1 = require("./customer-type");
const Nullable = (type) => typebox_1.Type.Union([type, typebox_1.Type.Null()]);
const sortByKey = typebox_1.Type.Union([
    typebox_1.Type.Literal('id'),
    typebox_1.Type.Literal('customerNumber'),
    typebox_1.Type.Literal('companyName'),
    typebox_1.Type.Literal('channel'),
    typebox_1.Type.Literal('type'),
    typebox_1.Type.Literal('businessType'),
]);
const sortDirection = typebox_1.Type.Union([typebox_1.Type.Literal('ASC'), typebox_1.Type.Literal('DESC')]);
exports.AdminPortalCustomerQuery = typebox_1.Type.Object({
    ids: typebox_1.Type.Optional(typebox_1.Type.String()),
    email: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    firstName: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    lastName: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    phoneNumber: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    companyName: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    channel: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    experience: typebox_1.Type.Optional(Nullable(typebox_1.Type.Boolean())),
    taxExempt: typebox_1.Type.Optional(Nullable(typebox_1.Type.Boolean())),
    type: typebox_1.Type.Optional(Nullable(customer_type_1.CustomerType)),
    businessType: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    reviewed: typebox_1.Type.Optional(Nullable(typebox_1.Type.Boolean())),
    doNotService: typebox_1.Type.Optional(Nullable(typebox_1.Type.Boolean())),
    sortBy: typebox_1.Type.Optional(sortByKey),
    sortDirection: typebox_1.Type.Optional(sortDirection),
    createdByUserId: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    createdAt_gte: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    createdAt_lte: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
    hasBalance: typebox_1.Type.Optional(Nullable(typebox_1.Type.Boolean())),
    accountManagerID: typebox_1.Type.Optional(Nullable(typebox_1.Type.String())),
});
//# sourceMappingURL=admin-portal-customer-query.js.map